export default {
  table: {
    emptyMsg: "You don't have any Wap app to display"
  },
  footer: {
    label: 'Apps created',
    tooltip:
      // eslint-disable-next-line max-len
      'If you reach the limit of created apps you will be unable to create new apps. To delete existing app or increase apps limit, please contact with Qrios support.'
  },
  dialog: {
    edit: {
      title: 'Edit WAP app'
    }
  },
  form: {
    appUrl: {
      label: 'App URL',
      placeholder: 'Enter app url'
    },
    status: {
      label: 'Status'
    },
    debugEnabled: {
      label: 'Run this app in debug mode'
    },
    authorizationMethod: {
      label: 'Authorization method'
    },
    smsTemplate: {
      label: 'Sms Template',
      placeholder: 'Enter template'
    },
    externalAddress: {
      label: 'External Address',
      placeholder: 'Enter external address'
    },
    process: {
      label: 'External Process',
      placeholder: 'Enter Process ID'
    },
    apiKey: {
      label: 'API key'
    }
  }
};
